module.exports = __webpack_public_path__ + "img/cdpzW.ac8e3ff2.png";